import React, { useState, useEffect } from 'react';
import { getUrgency } from '../../utils/kitchenConfig';
import './TimerDisplay.css';

const TimerDisplay = ({ orderTime, status }) => {
  const [elapsed, setElapsed] = useState('');
  const [urgency, setUrgency] = useState('normal');

  useEffect(() => {
    const updateTimer = () => {
      const now = Date.now();
      const orderDate = new Date(orderTime);
      const diff = Math.floor((now - orderDate) / 1000);
      const minutes = Math.floor(diff / 60);
      const seconds = diff % 60;
      setElapsed(`${minutes}:${seconds.toString().padStart(2, '0')}`);
      setUrgency(getUrgency(minutes));
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [orderTime]);

  return (
    <div className={`timer-display timer-display--${urgency}`}>
      <span className="timer-display__icon" aria-hidden>⏱</span>
      <span className="timer-display__value">{elapsed}</span>
    </div>
  );
};

export default TimerDisplay;
